import { render } from "./course1.vue?vue&type=template&id=496e72a5&scoped=true"
import script from "./course1.vue?vue&type=script&lang=js"
export * from "./course1.vue?vue&type=script&lang=js"

import "./course1.vue?vue&type=style&index=0&id=496e72a5&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496e72a5"]])

export default __exports__